import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */
import { OV_CDN } from '../../config/theme';
import css from './ImageScroller.module.scss';
var BASE_IMAGE_URL = "".concat(OV_CDN, "shopify/2.0.0/images/pages/rectrek/");
var MAIN_URL = '/collections/rectrek?category=Pants';
var W_PDP_URL = '/products/w-rectrek-pants';
var M_PDP_URL = '/products/m-rectrek-pant';
var heroImage = "".concat(BASE_IMAGE_URL, "hero.jpg");
var heroImageMobile = "".concat(BASE_IMAGE_URL, "hero-mobile.jpg");
var headline = 'One Pant, <br />A Million <br />Adventures';
var scrollerImages = [{
  alt: 'Man Stands in Rectrek Pant on rock in water',
  orderMobile: 1,
  src: "".concat(BASE_IMAGE_URL, "ugc-5.jpg")
}, // {
//   alt: 'Woman wears Rectrek Pant while dog walking, and poses',
//   orderMobile: 3,
//   src: `${BASE_IMAGE_URL}ugc-8.jpg`,
// },
// {
//   alt: 'Woman sitting in Rectrek Pant, poses surrounded by flowers',
//   orderMobile: 5,
//   src: `${BASE_IMAGE_URL}ugc-4.jpg`,
// },
// {
//   alt: 'Woman wearing Rectrek Pants adjusts climbing shoes',
//   orderMobile: 6,
//   src: `${BASE_IMAGE_URL}ugc-6.jpg`,
// },
{
  alt: 'Woman sitting on a fence wearing Rectrek Pant, smiles in front of mountain view',
  orderMobile: 0,
  src: "".concat(BASE_IMAGE_URL, "ugc-1.jpg")
} // {
//   alt: 'Man relaxes playfully in field wearing Rectrek Pants',
//   orderMobile: 2,
//   src: `${BASE_IMAGE_URL}ugc-3.jpg`,
// },
// {
//   alt: 'Woman poses in front of rugged rock wearing Rectrek Pants',
//   orderMobile: 4,
//   src: `${BASE_IMAGE_URL}ugc-7.jpg`,
// },
// {
//   alt: 'Woman near wall backdrop faces camera wearing Rectrek Pants',
//   orderMobile: 7,
//   src: `${BASE_IMAGE_URL}ugc-2.jpg`,
// },
];
var footerMarkup = "\n  <p class=\"".concat(css.shopQuote, "\">\n    \u201CLiterally the best pair <br class=\"").concat(css.mobile, "\">of <br class=\"").concat(css.desktop, "\">pants on this earth.\u201D\n  </p>\n    <p class=\"").concat(css.shopAuthor, "\">\u2014 Krista, OV Customer</p>\n");
var shopPoster = {
  cta: 'Shop Rectrek Pant',
  image: "".concat(BASE_IMAGE_URL, "footer.jpg"),
  message: footerMarkup,
  url: MAIN_URL
};
var featureBlock = {
  color: 'Bone',
  copy: 'Made in durable, elements-resistant Rectrek material, this iconic pant is built to brave the outdoors or a first date.',
  id: '0',
  image: "".concat(BASE_IMAGE_URL, "pant-bone-women.jpg"),
  price: 98,
  title: 'Rectrek Pant',
  url: "".concat(W_PDP_URL, "?variant=34894684229")
};
var props = {
  cta: {
    href: MAIN_URL,
    text: 'Shop Rectrek Pant'
  },
  featureBlocks: [_objectSpread(_objectSpread({}, featureBlock), {}, {
    id: 'first',
    imageRight: true
  }), _objectSpread(_objectSpread({}, featureBlock), {}, {
    color: 'Bone',
    id: 'second',
    image: "".concat(BASE_IMAGE_URL, "pant-bone-men.jpg"),
    imageRight: false,
    copy: 'New cut, same look. Here by popular demand, the Rectrek Pant are now available for men.',
    url: "".concat(M_PDP_URL, "?variant=32641628471374")
  }), _objectSpread(_objectSpread({}, featureBlock), {}, {
    color: 'Bone',
    id: 'third',
    image: "".concat(BASE_IMAGE_URL, "pant-bone-detail.jpg"),
    imageRight: true,
    copy: 'Shop our most versatile pant yet. Now available in fan-favorite colors.'
  })],
  heroImage: heroImage,
  heroImageMobile: heroImageMobile,
  price: 98,
  rating: 4.7,
  scrollerHeadline: headline,
  scrollerImages: scrollerImages,
  shopPoster: shopPoster,
  title: 'Rectrek Pant',
  url: MAIN_URL
};
export default props;